import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function EnterPriseNetworkServices() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero Banner */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100 mt-4">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Enterprise Network Services</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Network & NDR</div>
                                <h1 className="prod-hero-title">Enterprise <span>Network Services &amp; NDR</span></h1>
                                <p>Network Detection and Response technology constantly monitors network traffic to detect and respond to suspicious activities — enabling responsive, software-defined network architectures.</p>
                                <div className="button_services mb-4 mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/technology/zero-1.webp')} alt="Enterprise Network Services" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Overview</div>
                                <h2>Unlocking the Power of Enterprise Networks</h2>
                                <p>CLOUD MIND's Enterprise Network Services enable enterprises to develop responsive, software &amp; hardware defined network architectures that deliver quick provisioning, high availability, and increased reliability.</p>
                                <p>From data center networks and access networks to WAN, we help plan and design network structures for enhanced performance — aligned to your business needs.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Our Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4 Network Services */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Our Services</div>
                        <h2 className="prod-section-title">Network <span>Services Portfolio</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>End-to-end network management, security, and optimization for modern enterprises</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/icons/network.png')} alt="" style={{ width: 26, height: 26, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Network Strategy &amp; Consulting</h4>
                            <p>Assess the capacity and performance of your Network Architecture — data center, access network, or WAN — for a successful shift to software-defined architectures.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/icons/connectivity.png')} alt="" style={{ width: 26, height: 26, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Network &amp; Connectivity Management</h4>
                            <p>Deep expertise in managing telco-grade networks — LAN, WAN, SDWAN, SDNs, and industrial networks — while maintaining security and compliance per business needs.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/icons/communication.png')} alt="" style={{ width: 26, height: 26, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Unified Communications &amp; Voice</h4>
                            <p>High-performance communications delivered from cloud or on-premises. Includes Collaboration, Conferencing and Contact Center Infrastructure in a highly available architecture.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon">
                                <img src={require('../../../assets/images/services/products/icons/protecting.png')} alt="" style={{ width: 26, height: 26, filter: 'brightness(0) invert(1)' }} />
                            </div>
                            <h4>Protecting the Workforce, Wherever</h4>
                            <p>Self-Learning AI makes autonomous decisions to thwart in-progress attacks. In a world where attackers use AI, the ability for machines to augment humans is now a necessity.</p>
                            <div className="prod-feature-number">04</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/images (1).jpg')} alt="Network Benefits" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Benefits</div>
                                <h2>Why Enterprises Choose CLOUD MIND Networks</h2>
                                <ul className="prod-benefits-list">
                                    <li><span className="ben-dot">✓</span>Enhanced Security Monitoring and Threat Detection</li>
                                    <li><span className="ben-dot">✓</span>Improved Incident Response Time</li>
                                    <li><span className="ben-dot">✓</span>Proactive Threat Prevention and Compliance</li>
                                    <li><span className="ben-dot">✓</span>Optimized Network Performance and Reliability</li>
                                    <li><span className="ben-dot">✓</span>Reduced Network Downtime and Business Continuity</li>
                                    <li><span className="ben-dot">✓</span>Cost-Effective Risk Management</li>
                                    <li><span className="ben-dot">✓</span>Comprehensive Visibility Across the Network</li>
                                </ul>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '24px', display: 'inline-flex' }}>
                                    Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Modernize Your Network Infrastructure?</h3>
                            <p>Let our network experts design a resilient, secure, and high-performance architecture for your enterprise.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
